import { motion } from 'framer-motion';

export const Fade = ({
  delay = 0.4,
  duration = 0.5,
  once = true,
  ...rest
}: {
  delay?: number;
  duration?: number;
  once?: boolean;
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      viewport={{ once }}
      whileInView={{ opacity: 1, transition: { delay, duration } }}
      {...rest}
    />
  );
};
